import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

/** One member, because a project folder has no children of its own: what it holds is a membership
 *  of records that each live in their own component. */
class ProjectEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "Project";
        this.primaryEnterpriseComponent = "Project";

        const eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "Project";
        eom.enterpriseComponent = "Project";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ProjectEnterpriseObjectMetadata;
